import React, {Component} from "react";
import {Box} from "grommet/es6";

export default class TallBox extends Component {
  render() {
    return <Box height={{min: "100%"}}>{this.props.children}</Box>
  }
}

